import { render, staticRenderFns } from "./IndemnityPriceTemplateAddModal.vue?vue&type=template&id=85d87a50&scoped=true"
import script from "./IndemnityPriceTemplateAddModal.vue?vue&type=script&lang=js"
export * from "./IndemnityPriceTemplateAddModal.vue?vue&type=script&lang=js"
import style0 from "./IndemnityPriceTemplateAddModal.vue?vue&type=style&index=0&id=85d87a50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d87a50",
  null
  
)

export default component.exports